import React, { useCallback, useEffect, useMemo, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import { selectUser } from '@galo-monitor/stores/authentication/selectorAuthentication'
import { AVAILABLE_CONTEXTS, ContextActions } from '@galo-monitor/stores/context'
import { selectCurrentContextId, getContextIdBySlug } from '@galo-monitor/stores/context/selectorContext'
import { selectCurrentFarmId } from '@galo-monitor/stores/farm/selectorFarm'
import { selectCurrentPropertyId } from '@galo-monitor/stores/property/selectorProperty'
import { withLayout } from '@galo-monitor/web-containers/layouts'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import RouterSwitch from '../RouterSwitch'

const AuthenticatedScreenRouter = (props) => {
  const { routes } = useRoutes()

  const dispatch = useCallback(useDispatch(), [])

  const user = useSelector(selectUser)
  const currentContextId = useSelector(selectCurrentContextId)
  const currentFarmId = useSelector(selectCurrentFarmId)
  const currentPropertyId = useSelector(selectCurrentPropertyId)

  const waiting = useMemo(
    () => {
      switch (currentContextId) {
        case AVAILABLE_CONTEXTS.farm:
          return !!currentFarmId
        case AVAILABLE_CONTEXTS.property:
          return !!currentPropertyId
        default: return false
      }
    },
    [currentContextId, currentFarmId, currentPropertyId]
  )

  useEffect(
    () => {
      if (user.isAdmin)
        dispatch(AuthenticationActions.loadUserApplications())
    },
    [dispatch, user]
  )

  useEffect(
    () => {
      if (currentContextId || !isEmpty(user)) {
        dispatch(ContextActions.initContextById(currentContextId || getContextIdBySlug(toLower(user.context))))
      }

      if (!user.isAdmin) {
        dispatch(AuthenticationActions.loadUserApplicationsSuccess(user.functionalities))
      }
    },
    [currentContextId, currentPropertyId, dispatch, user]
  )

  return !waiting && <RouterSwitch routes={ routes } { ...props } />
}

export default memo(withLayout('authenticated')(AuthenticatedScreenRouter))
